const id = (value) => typeof value === 'string' && /^[a-f\d]{24}$/i.test(value);
const revision = (value) =>
  Number.isSafeInteger(value) && value >= 0 && value < Number.MAX_SAFE_INTEGER;
export const fundingReference = (value) =>
  typeof value === 'string' && /^[A-Za-z0-9][A-Za-z0-9._:-]{2,119}$/.test(value);
export const fundingDay = (value) =>
  typeof value === 'string' &&
  /^\d{4}-\d{2}-\d{2}$/.test(value) &&
  Number.isFinite(Date.parse(`${value}T00:00:00Z`)) &&
  new Date(`${value}T00:00:00Z`).toISOString().slice(0, 10) === value;

/** Private admin response only; deliberately separate from distributor purchase receipts. */
export function readMerchantFunding(response, purchase) {
  const value = response?.data?.data;
  if (
    !value ||
    value.purchaseId !== purchase._id ||
    value.method !== purchase.method ||
    !['ach', 'card'].includes(value.method) ||
    value.amountCents !== purchase.amountCents ||
    !Number.isSafeInteger(value.amountCents) ||
    value.amountCents < 1 ||
    value.amountCents > 9999999 ||
    value.currency !== 'USD' ||
    !revision(value.expectedAttemptRevision) ||
    typeof value.transactionId !== 'string' ||
    !/^[A-Za-z0-9._:-]{1,200}$/.test(value.transactionId) ||
    typeof value.realmId !== 'string' ||
    !/^[A-Za-z0-9][A-Za-z0-9._:-]{0,199}$/.test(value.realmId) ||
    typeof value.canConfirm !== 'boolean'
  )
    throw new Error('Invalid merchant funding');
  const evidence = value.merchantFunding;
  if (
    evidence !== null &&
    (!evidence ||
      evidence.version !== 1 ||
      evidence.source !== 'quickbooks_merchant_service_center' ||
      evidence.status !== 'Funded' ||
      typeof evidence.requestKey !== 'string' ||
      !/^[A-Za-z0-9_-]{16,100}$/.test(evidence.requestKey) ||
      !revision(evidence.expectedAttemptRevision) ||
      evidence.expectedAttemptRevision > value.expectedAttemptRevision ||
      !id(evidence.confirmedBy) ||
      typeof evidence.recordedAt !== 'string' ||
      !Number.isFinite(Date.parse(evidence.recordedAt)) ||
      evidence.realmId !== value.realmId ||
      evidence.transactionId !== value.transactionId ||
      evidence.amountCents !== value.amountCents ||
      evidence.currency !== value.currency ||
      typeof evidence.intentHash !== 'string' ||
      !/^[a-f\d]{64}$/.test(evidence.intentHash) ||
      !fundingReference(evidence.depositReference) ||
      !fundingDay(evidence.fundedDate) ||
      value.canConfirm)
  )
    throw new Error('Invalid merchant evidence');
  return value;
}

export function matchesFundingIntent(value, intent, actorId) {
  return Boolean(
    value.merchantFunding &&
      value.expectedAttemptRevision > intent.expectedAttemptRevision &&
      value.merchantFunding.confirmedBy === actorId &&
      [
        'requestKey',
        'expectedAttemptRevision',
        'realmId',
        'transactionId',
        'amountCents',
        'currency',
        'depositReference',
        'fundedDate',
      ].every((key) => value.merchantFunding[key] === intent[key])
  );
}
